import { render } from "./VendorSlider.vue?vue&type=template&id=dbbfcc82&scoped=true"
import script from "./VendorSlider.vue?vue&type=script&lang=js"
export * from "./VendorSlider.vue?vue&type=script&lang=js"

import "./VendorSlider.vue?vue&type=style&index=0&id=dbbfcc82&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbbfcc82"]])

export default __exports__